<template>
  <v-col cols="auto">
    <v-dialog v-model="dialog" transition="dialog-transition" max-width="60%">
      <template v-slot:activator="{ on, attrs }">
        <v-toolbar color="transparent" class="top-modal-openers" flat>
          <v-btn color="var(--prussian-blue)" v-bind="attrs" v-on="on" @click="setTab('about')" text
            class="modal-open-btn">About</v-btn>
          <v-btn color="var(--prussian-blue)" v-bind="attrs" v-on="on" @click="setTab('resources')" text
            class="modal-open-btn">Resources</v-btn>
          <v-btn color="var(--prussian-blue)" v-bind="attrs" v-on="on" @click="setTab('share')" text
            class="modal-open-btn">Share</v-btn>
          <v-btn color="var(--prussian-blue)" v-bind="attrs" v-on="on" @click="setTab('print')" text
            class="modal-open-btn">Print</v-btn>
          <!-- Uncomment to show data-note modal button inside the modal at the top: -->
          <!-- <v-btn
            color="var(--prussian-blue)"
            v-bind="attrs"
            v-on="on"
            @click="setTab('data-note')"
            text
            class="modal-open-btn"
            >Data Note</v-btn
          > -->

          <!-- SR temporarily commented out Data tab 3/1/21 -->
          <!-- <v-btn
          color="var(--prussian-blue)"
          v-bind="attrs"
          v-on="on"
          @click="setTab('data')"
          text
          class="modal-open-btn"
          >Data</v-btn
        > -->
        </v-toolbar>
      </template>
      <template v-slot:default="dialog">
        <v-card rounded="0">
          <v-toolbar class="tab-switch" color="var(--powder-blue)">
            <span v-show="!['data-note', 'update'].includes(activeTab)">
              <v-btn color="var(--prussian-blue)" @click="setTab('about')" text
                class="modal-open-btn toolbar-switch">About</v-btn>
              <v-btn color="var(--prussian-blue)" @click="setTab('resources')" text
                class="modal-open-btn toolbar-switch">Resources</v-btn><v-btn color="var(--prussian-blue)"
                @click="setTab('share')" text class="modal-open-btn toolbar-switch">Share</v-btn>

              <v-btn color="var(--prussian-blue)" @click="setTab('print')" text
                class="modal-open-btn toolbar-switch">Print</v-btn>

              <!-- Uncomment next button to show data-note modal button inside the modal at the top: -->
              <!-- <v-btn
              color="var(--prussian-blue)"
              @click="setTab('data-note')"
              text
              class="modal-open-btn toolbar-switch"
              >Data Note</v-btn
            > -->

              <!-- <v-btn
              color="var(--prussian-blue)"
              @click="setTab('data')"
              text
              class="modal-open-btn toolbar-switch"
              >Data</v-btn
            > -->
            </span>
            <header class="note-header" v-show="activeTab === 'data-note'">
              DATA NOTE
            </header>
            <v-icon @click="dialog.value = false" class="modal-close">mdi-close-thick</v-icon>
          </v-toolbar>
          <v-card-text>
            <!-- <div class="text-h2 pa-12"> SET THIS FOR DEFAULT TEXT -->
            <div class="pt-4 px-2 pb-2" style="color: rgba(0, 0, 0, 1)">
              <ModalUpdate v-show="activeTab === 'update'" />
              <ModalAbout v-show="activeTab === 'about'" />
              <ModalResources v-show="activeTab === 'resources'" />
              <ModalShare :url="shareUrl" v-show="activeTab === 'share'" />
              <ModalPrint ref="printModal" v-show="activeTab === 'print'" />
              <ModalDataNote v-show="activeTab === 'data-note'" />
              <!-- <ModalData v-show="activeTab === 'data'" /> -->
            </div>
            <v-card-actions class="justify-end">
              <v-btn text @click="dialog.value = false">Close</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>
  </v-col>
</template>
<script>
import ModalUpdate from "./ModalUpdate.vue";
import ModalAbout from "./ModalAbout";
// import ModalData from "./ModalData";
import ModalResources from "./ModalResources";
import ModalShare from "./ModalShare";
import ModalPrint from "./ModalPrint";
import ModalDataNote from "./ModalDataNote";
// import { Config } from "../../../data/Config/Config";
import { EventBus } from "../../js/DataManagement/EventBus";
import $ from "jquery";
export default {
  name: "Modal",
  components: {
    ModalUpdate,
    ModalAbout,
    // ModalData,
    ModalDataNote,
    ModalResources,
    ModalShare,
    ModalPrint,
  },
  data: function () {
    return {
      activeTab: "",
      shareUrl: "",
      //Config: Config,
      dialog: null,
    };
  },
  mounted: function () {
    EventBus.$on("close-modal", () => {
      this.dialog = false;
    });
    EventBus.$on("open-modal", (_tab) => {
      this.dialog = true;
      this.setTab(_tab);
    });

    $("#loading").remove();

    // show ModalUpdate when there are no url params
    const urlParams = new URLSearchParams(window.location.search);
    const paramsObject = Object.fromEntries(urlParams.entries());

    if (!Object.keys(paramsObject).length) {
      EventBus.$emit("open-modal", "update");
    }
  },
  updated: function () {
    $("#print-info-container").html(
      $($(".side-menu-container")[0]).html() +
      $($(".side-menu-container")[1]).html()
    );
  },
  watch: {
    dialog: function () {
      //this.$store.commit("setDialogOpen", val);
    },
  },
  methods: {
    setTab(val) {
      this.setShareUrl();
      this.clearPrintImg();
      this.activeTab = val;
      EventBus.$emit("set-modal", val);
    },
    modalOn: function () {
      //console.log("m on");
    },
    setShareUrl() {
      this.shareUrl = location.href;
    },
    clearPrintImg() {
      if (this.$refs.printModal) {
        this.$refs.printModal.clearImg();
      }
    },
  },
};
</script>
<style>
.modal-open-btn {
  color: var(--prussian-blue);
  height: 50px !important;
  background: rgb(0 0 0 / 2%);
  border: 1px solid #00000014;
  margin-right: 8px;
  border-radius: 0;
  caret-color: var(--prussian-blue);
}

.modal-open-btn.toolbar-switch {
  margin-left: 8px;
  margin-right: 0;
}

.top-modal-openers {
  height: 50px;
  background: transparent;
  background-color: transparent;
}

.top-modal-openers div {
  padding: 8px;
}

.tab-switch .v-toolbar__content {
  padding: 0;
}

.v-icon.v-icon.modal-close {
  right: 10px;
  position: absolute;
  cursor: pointer;
  color: black;
}

.note-header {
  padding: 32px;
  font-size: 1.2em;
}
</style>